import React, { useState } from 'react'
import { hexToRgb } from '../utils'

import './color_picker.css'

const COLORS = [
  '#f1c9bc',
  '#ebe9d5',
  '#e9edeb',
  '#f1e5e1',
  '#ffe8c5',
  '#ffd7b4',
  '#dcd3dd',
  '#b9d0ee',
  '#bce1d2',
  '#dd7758',
  '#ccc897',
  '#c9d1ce',
  '#dbbcb3',
  '#ffd28c',
  '#ffaf69',
  '#965a9b',
  '#73a0dc',
  '#78c3a5',
]

const EXTRA_COLORS = [['#fbe89d', 'offers']]

export function ColorPicker({
  label,
  value,
  onChange,
  suggested = true,
  extraColors = EXTRA_COLORS,
}) {
  const [error, setError] = useState('')
  const errorStyles = {
    fontSize: 12,
    textAlign: 'right',
    color: 'red',
    marginBottom: 10,
  }

  function change(e) {
    const color = e.target.value
    const isDefined = color && color.length
    const isValid = color.match(/^#[0-9A-Fa-f]{6}$/)
    setError(isDefined && !isValid ? `The color ${color} doesn't exist` : '')
    onChange(e)
  }

  function renderColor(colorInfo) {
    const isAnArray = Array.isArray(colorInfo)
    const color = isAnArray ? colorInfo[0] : colorInfo
    const label = isAnArray ? colorInfo[1] : ''
    const rgb = hexToRgb(color)
    const brightness = Math.round(
      (parseInt(rgb[0]) * 299 +
        parseInt(rgb[1]) * 587 +
        parseInt(rgb[2]) * 114) /
        1000
    )
    const textColor = brightness > 125 ? 'black' : 'white'

    return (
      <div
        key={color}
        className="suggested-color"
        style={{
          backgroundColor: color,
          color: textColor,
        }}
      >
        <p>
          {label ? `${label}: ` : ''}
          {color}
        </p>
      </div>
    )
  }

  return (
    <div style={{ marginTop: 10, marginBottom: 10 }} className="form-part">
      {label && <label className="label">{label}</label>}
      <div style={{ marginBottom: 0 }} className="field has-addons">
        <p className="control">
          <input
            type="color"
            className="input-color"
            value={value}
            onChange={change}
          />
        </p>
        <p className="control is-expanded">
          <input
            className="input"
            type="text"
            value={value}
            onKeyDown={change}
            onChange={change}
          />
        </p>
      </div>
      {error && (
        <div className="error-message" style={errorStyles}>
          The color {value} is not correct
        </div>
      )}
      {suggested && (
        <details>
          <summary style={{ fontSize: 12 }}>Suggested colors</summary>
          {extraColors.map(renderColor)}
          {extraColors?.length > 0 && (
            <div style={{ fontSize: 12 }}>More suggestions:</div>
          )}
          {COLORS.map(renderColor)}
        </details>
      )}
    </div>
  )
}
